import { createTheme } from "@mui/material/styles";
import { grey, orange } from "@mui/material/colors";
import { primary, white } from "./constants";

const defaultTheme = createTheme({
  palette: {
    primary: {
      main: primary,
    },
    secondary: {
      main: orange.A700,
    },
    background: {
      default: white,
    },
    grey,
  },
  typography: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: 14,
    h1: {
      fontSize: "2.2rem",
    },
    h3: {
      fontSize: "34px",
      fontWeight: "500",
      lineHeight: "51px",
    },
    h4: {
      fontSize: "18px",
      fontWeight: "600",
      lineHeight: "24px",
    },
    h5: {
      fontSize: "18px",
      fontWeight: "400",
      color: "#1D1B1B",
      lineHeight: "24px",
    },
    body2: {
      fontSize: "14px",
      fontWeight: "400",
    },
    body1: {
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "21px",
    },
  },
});

export default defaultTheme;

// export const getDesignTokens = (mode: ThemeMode) => {
//   return mode === ThemeMode.dark ? darkTheme : lightTheme;
// };
